import { render, staticRenderFns } from "./actionsProperty.vue?vue&type=template&id=b3087420&scoped=true&"
import script from "./actionsProperty.vue?vue&type=script&lang=js&"
export * from "./actionsProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3087420",
  null
  
)

export default component.exports